import request from '@/utils/request'
export const getGoodsList = (goods) => {
  return request.get('/goods/list', {
    params: goods
  })
}
export const getTop5GoodsList = () => {
  return request.get('/goods/top5')
}
export const getGoodsInfo = (id) => {
  return request.get(`/goods/${id}`)
}
export const getMyGoods = (pageNo, pageSize) => {
  return request.get('/goods', {
    params: {
      pageNo,
      pageSize
    }
  })
}
export const addGoods = (goods) => {
  return request.post('/goods', goods)
}
export const updateGoods = (goods) => {
  return request.put('/goods', goods)
}
export const deleteGoods = (goodsId, pageNo, pageSize) => {
  const goodsIds = goodsId.join(',')
  return request.delete('/goods', {
    params: {
      goodsIds,
      pageNo,
      pageSize
    }
  }
  )
}
